// Operating hours by day of week for Buffet des Continents
// Based on Libro schedule

export const OPERATING_HOURS = {
  // Monday - Thursday: Dinner only
  1: [{ start: '17:00', end: '20:30' }], // Monday
  2: [{ start: '17:00', end: '20:30' }], // Tuesday
  3: [{ start: '17:00', end: '20:30' }], // Wednesday
  4: [{ start: '17:00', end: '20:30' }], // Thursday
  
  // Friday: Extended dinner
  5: [{ start: '17:00', end: '21:30' }], // Friday
  
  // Saturday: Lunch + Dinner
  6: [
    { start: '11:00', end: '14:30' }, // Lunch
    { start: '16:00', end: '21:30' }  // Dinner
  ],
  
  // Sunday: Lunch + Dinner
  0: [
    { start: '11:00', end: '14:30' }, // Lunch
    { start: '16:00', end: '20:30' }  // Dinner
  ]
};

// Generate 15-minute time slots for a specific day
export const generateTimeSlots = (date) => {
  const dayOfWeek = date.getDay();
  const schedules = OPERATING_HOURS[dayOfWeek] || [];
  
  const slots = [];
  
  schedules.forEach(schedule => {
    const [startHour, startMin] = schedule.start.split(':').map(Number);
    const [endHour, endMin] = schedule.end.split(':').map(Number);
    
    let currentHour = startHour;
    let currentMin = startMin;
    
    while (
      currentHour < endHour || 
      (currentHour === endHour && currentMin <= endMin)
    ) {
      const timeString = `${String(currentHour).padStart(2, '0')}:${String(currentMin).padStart(2, '0')}`;
      slots.push(timeString);
      
      currentMin += 15;
      if (currentMin >= 60) {
        currentMin = 0;
        currentHour += 1;
      }
    }
  });
  
  return slots;
};

// Check if restaurant is open at specific time
export const isOpenAt = (date, time) => {
  const dayOfWeek = date.getDay();
  const schedules = OPERATING_HOURS[dayOfWeek] || [];
  
  return schedules.some(schedule => {
    return time >= schedule.start && time <= schedule.end;
  });
};

// Get service period name
export const getServicePeriod = (time, dayOfWeek) => {
  const [hour] = time.split(':').map(Number);
  
  // Weekend has both lunch and dinner
  if (dayOfWeek === 0 || dayOfWeek === 6) {
    if (hour < 15) return 'Lunch';
    return 'Dinner';
  }
  
  // Weekdays only have dinner
  return 'Dinner';
};
